import { ActionCreator } from "redux";
import {
  LoadClinicInformationAction,
  CleanSiteInformationAction,
  IClinicInformationPayload
} from "./type";
import {
  LOAD_CLINIC_INFORMATION,
  CLEAN_SITE_INFORMATION
} from "./constants";

export const loadClinicInformation: ActionCreator<LoadClinicInformationAction> = (clinicInfo: IClinicInformationPayload) => ({
    type: LOAD_CLINIC_INFORMATION,
    payload: clinicInfo,
});

export const cleanSiteInformation: ActionCreator<CleanSiteInformationAction> = () => ({
    type: CLEAN_SITE_INFORMATION
});



// WEBPACK FOOTER //
// ./src/store/ClinicInformation/actions.ts